import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UserAdressLocationFormComponent } from '../../user-profile/@components/user-address-card/@toasts/edit-user-adress-toast/user-adress-location-form/user-adress-location-form.component';
import { GardenBedCreateComponent } from '../garden-bed/garden-bed-create/garden-bed-create.component';

interface AddedBed {
  name: string;
  type: string;
  rows?: number;
  columns?: number;
  capacity?: number;
}

/**
 * Wizard de création de zone en 2 étapes :
 *  1. La zone (réutilise vw-user-adress-location-form).
 *  2. Les planches (réutilise vw-garden-bed-create inline, autoNavigate=false).
 * La zone est persistée à l'étape 1 ; un abandon à l'étape 2 laisse une zone valide sans planche.
 */
@Component({
  selector: 'vw-zone-create-wizard',
  imports: [CommonModule, TranslateModule, UserAdressLocationFormComponent, GardenBedCreateComponent],
  templateUrl: './zone-create-wizard.component.html',
  styleUrl: './zone-create-wizard.component.scss',
})
export class ZoneCreateWizardComponent {
  @Output() finished = new EventEmitter<any>();

  step: 1 | 2 = 1;
  createdLocation?: any;
  addedBeds: AddedBed[] = [];
  showAddBedSheet = false;

  onZoneCreated(location?: any): void {
    if (location?.uid) {
      this.createdLocation = location;
      this.step = 2;
    } else {
      // Annulation (back) depuis le formulaire de zone → on ferme le wizard.
      this.finished.emit(undefined);
    }
  }

  openAddBed(): void {
    this.showAddBedSheet = true;
  }

  closeAddBed(): void {
    this.showAddBedSheet = false;
  }

  onBedCreated(bed: any): void {
    this.addedBeds.push({
      name: bed?.name,
      type: bed?.type,
      rows: bed?.rows,
      columns: bed?.columns,
      capacity: bed?.capacity,
    });
    this.showAddBedSheet = false;
  }

  finish(): void {
    // On renvoie la zone créée pour signaler au parent qu'il faut recharger le potager.
    this.finished.emit(this.createdLocation);
  }
}
